/**
 * @file Anything that can run on every page.
 */
// test3
import vHeader from '../components/header/header';
import vOffCanvasNav from '../components/off-canvas-nav/off-canvas-nav';
import vSearchForm from '../components/search-form/search-form';
import vWeightCalculator from '../components/boat-weight-calculator-form/boat-weight-calculcator';
import vFullScreenBgText from '../components/full-screen-bg-text/full-screen-bg-text';
import vVideo from '../components/video/video';
import vTrailerTypeSelection from '../components/trailer-type-selection/trailer-type-selection';
import vCardLink from '../components/card-link/card-link';
import Account from '../components/my-account/my-account';
import vSingleResourceAccordion from '../components/single-resource-accordion/single-resource-accordion';
import vCheckmarkList from '../components/checkmark-list/checkmark-list';
import vGravityForms from '../components/form/v-gravity-form';
import vFindADealer from './find-a-dealer';
import vSingleProduct from '../templates/single-product/single-product';
import vCustomNumberRange from '../components/custom-number-range/custom-number-range';
import vResourceSelection from '../components/resource-selection/resource-selection';
import customFont from './custom-font';
import characterCounter from './character-counter';
import vMiniCart from '../components/mini-cart/mini-cart';
import vGravityFormsMods from './gravity-forms-mods';
import vWcCheckout from './wc-checkout';

window.jQuery.datepicker.setDefaults(window.jQuery.datepicker.regional['']);

/**
 * Global functions.
 *
 * Runs component js and any global tasks.
 */
const vGlobal = () => {
	vOffCanvasNav();
	vHeader();
	vSearchForm();
	vMiniCart();
	vWeightCalculator();
	vFullScreenBgText();
	vVideo();
	vTrailerTypeSelection();
	vCardLink();
	vSingleResourceAccordion();
	vCheckmarkList();
	vGravityForms();
	vSingleProduct();
	vCustomNumberRange();
	vResourceSelection();
	customFont();
	characterCounter();
	Account.init();
	vFindADealer.init();
	vGravityFormsMods();
	vWcCheckout();

	const updateCartCountFromTable = () => {
        let total = 0;
				const quantities = document.querySelectorAll('.woocommerce-cart-form .quantity input.qty');
				if(quantities) {
					quantities.forEach((qty) => {
							total += parseInt(qty.value, 10) || 0;
					});
				}

        window.jQuery('.v-header__cart-count')
					.text(total)
					.attr('data-cart-count', total);
    }

    // Instant update when cart is updated via AJAX
    window.jQuery(document.body).on('updated_wc_div', () => {
        updateCartCountFromTable(); // instant update
        window.jQuery(document.body).trigger('wc_fragment_refresh'); // refresh from server for accuracy
    });

	/**
	 * Apply full-width class to table column (Specifically Model and Tire Size)
	 */
	const accordions = document.querySelectorAll('.v-trailer-type-selection .v-trailer-type-selection__accordion');
	if(accordions.length) {
		accordions.forEach(acc => {
			const titles = acc.querySelectorAll('tr:first-of-type td');
			if(titles.length) {
				titles.forEach((title, idx) => {
					if(title.textContent.includes('Model') || title.textContent.includes('Tire Size')) {
						title.classList.add('v-trailer-type-selection__nowrap');
						const childColumns = acc.querySelectorAll('tr:not(:first-of-type)');
						if(childColumns.length) {
							childColumns.forEach(cc => {
								cc.querySelector(`td:nth-of-type(${idx + 1})`).classList.add('v-trailer-type-selection__nowrap');
							})
						}
					}
				});
			}
		});
	}

	if (document.querySelectorAll('.facetwp-facet').length) {
		import('../components/facet-filters/facet-filters').then(
			({ default: vFacetFilters }) => {
				vFacetFilters();
			},
		);
	}

	import('../components/dropdown/dropdown').then(({ default: vDropdown }) => {
		vDropdown();
	});

	/* Prevent checkout form from submitting by hitting enter on one of the fields */
	const checkoutForm = document.querySelector('.woocommerce-checkout.v-woocommerce-form');
	if(checkoutForm) {
		checkoutForm.addEventListener('keydown', (event) => {
			if(event.key == "Enter") {
				event.preventDefault();
			}
		});
	}

	/* archive-product.php page - scroll down to search results on search */
	const scrollToResults = setInterval(() => {
		const shopPage = document.querySelector('.v-woocommerce-shop-search-results');
		const results = document.querySelector('.v-woocommerce-shop-list');
		if(! shopPage) return;
		const resultsPosition = results.offsetTop;

		const params = new URLSearchParams(window.location.search);
		const search = params.get('s');
		const orderby = params.get('orderby');

		if (! shopPage || (! search && ! orderby)) {
			clearInterval(scrollToResults);
			return;
		}

		if(resultsPosition) {
			window.scrollTo({
				behavior: 'smooth',
				top: resultsPosition - 100
			});
			clearInterval(scrollToResults);
		}

	}, 500);

	const floatingLabelWraps = document.querySelectorAll(
		'.v-form__floating-label-wrap',
	);
	[...floatingLabelWraps].forEach((wrap) => {
		const label = wrap.querySelector('.v-form__floating-label');
		const input = wrap.querySelector('input, select');

		input.addEventListener('focus', () => {
			label.classList.add('v-form__floating-label--float');
		});

		input.addEventListener('blur', () => {
			if (input.value === '') {
				label.classList.remove('v-form__floating-label--float');
			}
		});
	});

	const scrollBarWidth =
		window.innerWidth - document.documentElement.clientWidth;
	document.documentElement.style.setProperty(
		'--scroll-bar-width',
		`${scrollBarWidth}px`,
	);

	/**
	 * Global Window Load.
	 *
	 * Runs polyfills on page load.
	 */
	async function onWindowLoad() {
		const body = document.querySelector('body');
		if (!body.classList.contains('admin-bar')) {
			// const { listen } = await import('quicklink');
			// listen({
			// 	ignores: [
			// 		(url) => {
			// 			const cleanUrl = url.replace(/#.*/, '');
			// 			return cleanUrl === window.location.href;
			// 		},
			// 		/.*\/wp-admin\/.*/,
			// 	],
			// });
		}
	}

	if (document.readyState === 'complete') {
		onWindowLoad();
	} else {
		window.addEventListener('load', onWindowLoad);
	}
};

if (document.readyState !== 'loading') {
	vGlobal();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		vGlobal();
		vHeader();
		vOffCanvasNav();
	});
}
